import { CanteenRole } from 'core/models/canteen.model';
import { NavItem } from 'core/models/nav-item.model';

const DASHBOARD: NavItem = {
  route: '/dashboard',
  label: 'Painel',
  iconClass: 'speedometer2',
};

const MENU: NavItem = {
  route: '/menu',
  label: 'Cardápio',
  iconClass: 'journal-richtext',
};

const ORDERS: NavItem = {
  route: '/orders',
  label: 'Pedidos',
  iconClass: 'receipt',
};

export function canteenNav(role: CanteenRole): readonly NavItem[] {
  if (role === 'STUDENT') {
    return [DASHBOARD, MENU, ORDERS];
  }

  if (role === 'GUARDIAN') {
    return [
      DASHBOARD,
      MENU,
      ORDERS,
      {
        route: '/students',
        label: 'Alunos',
        iconClass: 'people',
      },
    ];
  }

  const operation: NavItem[] = [
    DASHBOARD,
    {
      route: '/pos',
      label: 'PDV',
      iconClass: 'cart3',
    },
    ORDERS,
    {
      route: '/pickup',
      label: 'Retirada',
      iconClass: 'qr-code',
    },
    {
      route: '/students',
      label: 'Alunos',
      iconClass: 'people',
    },
    {
      route: '/inventory',
      label: 'Estoque',
      iconClass: 'box-seam',
    },
    {
      route: '/cashier',
      label: 'Caixa',
      iconClass: 'cash-stack',
    },
  ];

  if (role === 'CANTEEN_OPERATOR') {
    return operation;
  }

  const management: NavItem[] = [
    ...operation.slice(0, 1),
    {
      route: '/categories',
      label: 'Categorias',
      iconClass: 'tags',
    },
    {
      route: '/products',
      label: 'Produtos',
      iconClass: 'basket',
    },
    ...operation.slice(1),
    {
      route: '/reports',
      label: 'Relatórios',
      iconClass: 'bar-chart-line',
    },
  ];

  if (role === 'CANTEEN_MANAGER') {
    return management;
  }

  return [
    ...management,
    {
      route: '/settings',
      label: 'Configurações',
      iconClass: 'gear',
    },
  ];
}
